import React from "react";
import { TextField } from "formik-material-ui";
import Button from "@material-ui/core/Button";
import { useSnackbar } from "notistack";
import Box from "@material-ui/core/Box";
import { Formik, Form, Field, FormikProps } from "formik";
import * as Yup from "yup";
import { Link, useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import API from "../../../helpers/apiHelpers";
import {useAppDispatch} from "../../../redux/store";
import {patchPassword} from "../../../redux/user/user.actions";

export default () => {
    const location = useLocation();
    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .min(8, "Too Short!")
            .required("Required"),
        passwordConfirm: Yup.string()
            .oneOf([Yup.ref("password")], "Passwords must match")
            .required("Required"),
    });
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const dispatch = useAppDispatch();
    return (
        <Formik
            initialValues={{
                password: "",
                passwordConfirm: "",
            }}
            onSubmit={async (values, {setStatus}) => {
                try {
                    const { state } = queryString.parse(location.search);
                    const body = `password=${values.password}&state=${state}`;
                    await dispatch(patchPassword(body));
                    // await API.patchPassowrd(body);
                    enqueueSnackbar("your password has changed");
                    history.push("/login");
                    setStatus({success: true});
                } catch (error) {
                    enqueueSnackbar("Error while changing password", {
                        variant: "error",
                        autoHideDuration: 3000,
                    });
                    setStatus({success: false});
                } finally {
                    document.cookie.split(";").forEach(function(c) {
                        document.cookie = c.trim().split("=")[0] + "=;" + "expires=Thu, 01 Jan 1970 00:00:00 UTC;";
                    });
                }
            }}
            validationSchema={validationSchema}
        >
            {
                (props: FormikProps<{password: string, passwordConfirm: string}>) => (
                    <Form>
                        <Box
                            display="flex"
                            flexDirection="column"
                            width="100%"
                            marginBottom="16px"
                        >
                            <Field
                                component={TextField}
                                label="Password"
                                name="password"
                                variant="outlined"
                                color="secondary"
                                type="password"
                                margin="normal"
                                onChange={props.handleChange}
                                value={props.values.password}
                            />
                            <Field
                                component={TextField}
                                label="Confirm Password"
                                name="passwordConfirm"
                                variant="outlined"
                                color="secondary"
                                type="password"
                                margin="normal"
                                onChange={props.handleChange}
                                value={props.values.passwordConfirm}
                            />
                        </Box>
                        <Box
                            marginBottom={"10pt"}
                        >
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                data-testid="submitButton"
                                fullWidth
                            >
								Reset
                            </Button>
                        </Box>
                        <Link to="/login" style={{textDecoration: "none"}}>
                            <Button
                                color="default"
                                variant="contained"
                                data-testid="submitButton"
                                fullWidth
                            >
								Back to Sign in
                            </Button>
                        </Link>
                    </Form>
                )
            }
        </Formik>
    );
};
